<template>
  <div id="app">
    <!-- <div id="app" v-app-scroll style="height: 100vh;overflow-y: scroll;"> -->
    <div id="nav">
      <router-view v-if="$route.meta.isLogin"></router-view>
      <admin-home v-if="$route.meta.isAdmin" />
      <Home v-if="Showhome" />
    </div>
  </div>
</template>
<script>
import Home from "../src/views/Home.vue";
import AdminHome from "../src/views/Home1.vue";
export default {
  components: { Home, AdminHome },
  data() {
    return {
      Showhome: false,
    };
  },
  watch: {
    $route(to, from) {
      if (to.meta.isAdmin || to.meta.isLogin) {
        this.Showhome = false;
      } else {
        this.Showhome = true;
      }
    },
  },
};
</script>
<style lang="scss">
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif,;
  font-family: Cotyledon-Regular;
  // font-size:20px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #fff;
  display: flex;
  justify-content: space-around;
}

#nav {
  width: 100%;
  min-height: 100vh;
  background-color: #f8fafc;
  // a {
  //   // font-weight: bold;
  //   color: #2c3e50;

  //   &.router-link-exact-active {
  //     color: #42b983;
  //   }
  // }
}
</style>
